import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetWarranty = createAsyncThunk<AxiosResponse<any, any>, string>(
  "warranty/toGetWarranty",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/warranty?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
